import type { MockServer } from '../server'

export function routes(server: MockServer) {
  server.get('/departments/:id/consultation_types', function () {
    return {
      data: [
        {
          type: 'ConsultationType',
          id: '0',
          attributes: {
            value: 'INPATIENT',
            label: 'Inpatient',
            active: true,
          },
        },
        {
          type: 'ConsultationType',
          id: '1',
          attributes: {
            value: 'OUTPATIENT',
            label: 'Outpatient',
            active: true,
          },
        },
        {
          type: 'ConsultationType',
          id: '2',
          attributes: {
            value: 'HOME_CALL',
            label: 'Home call',
            active: true,
          },
        },
        {
          type: 'ConsultationType',
          id: '3',
          attributes: {
            value: 'FARM_VISIT',
            label: 'Farm visit',
            active: true,
          },
        },
        {
          type: 'ConsultationType',
          id: '4',
          attributes: {
            value: 'BOARDING',
            label: 'Boarding',
            active: true,
          },
        },
        {
          type: 'ConsultationType',
          id: '5',
          attributes: {
            value: 'PET_SERVICE',
            label: 'Pet service',
            active: true,
          },
        },
      ],
    }
  })
}
